import Grid from '@mui/material/Grid'

import ManageMemberTypes from '../ManageMemberTypes'
import ManageOrganisations from '../ManageOrganisations'
import SeverityTimelineComponent from '../SeverityTimeline'

function MainContent() {
	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<ManageOrganisations />
			</Grid>
			<Grid item xs={12}>
				<ManageMemberTypes />
			</Grid>
			<Grid item xs={12}>
				<SeverityTimelineComponent />
			</Grid>
		</Grid>
	)
}

export default MainContent
